import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  OnDestroy,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators,
} from "@angular/forms";
import { commonVar } from "../../../../providers/common-var/common";
import { CompanyDetails } from "../company-details";

// TODO make this work
@Component({
  selector: "company-details-details",
  templateUrl: "company-details-details.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CompanyDetailsDetails),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CompanyDetailsDetails),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyDetailsDetails
  extends CompanyDetails
  implements ControlValueAccessor, OnDestroy
{
  @Input() isEditMode: boolean = false;

  stateList = commonVar.STATE_LIST;
  countryList = commonVar.COUNTRIES;

  phoneMask = commonVar.PHONE_US_MASK;
  zipCodeMask = commonVar.ZIP_CODE_MASK;

  set value(value: any) {
    console.log("Inner being patched");
    console.log(value);
    if (value.phone)
      value.phone = value.phone.replace(
        /^(\d{3})(\d{3})(\d{4}).*/,
        "($1)$2-$3"
      );
    if (value.phone2)
      value.phone2 = value.phone2.replace(
        /^(\d{3})(\d{3})(\d{4}).*/,
        "($1)$2-$3"
      );
    if (value.fax)
      value.fax = value.fax.replace(/^(\d{3})(\d{3})(\d{4}).*/, "($1)$2-$3");
    if (value.country === "") value.country = "United States";
    this.innerFormGroup.patchValue(value);
  }

  constructor(protected formBuilder: FormBuilder) {
    super(formBuilder);

    // create inner form
    this.innerFormGroup = this.formBuilder.group({
      name: [null, [Validators.required, Validators.maxLength(75)]],
      email: [
        null,
        [Validators.pattern(commonVar.EMAIL_REGEX), Validators.maxLength(75)],
      ],
      emailDomain: [
        null,
        [
          Validators.pattern(commonVar.EMAIL_DOMAIN_REGEX),
          Validators.maxLength(75),
        ],
      ],
      website: [null, [Validators.pattern(commonVar.WEBSITE_REGEX)]],
      phone: [null, [Validators.required, Validators.minLength(13)]],
      phone2: [null, [Validators.minLength(13)]],
      fax: [null, [Validators.minLength(13)]],
      country: [null, Validators.required],
      address: [null, [Validators.required]],
      address2: [null],
      city: [null, [Validators.required]],
      state: [null, Validators.required],
      postal: [null, [Validators.required, Validators.minLength(5)]],
    });

    this.subscriptions.push(
      this.innerFormGroup.valueChanges.subscribe((value) => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  valid(control: string) {
    return this.innerFormGroup.get(control).valid;
  }

  touched(control: string) {
    return this.innerFormGroup.get(control).touched;
  }

  validate(_: FormControl) {
    return this.innerFormGroup.valid ? null : { details: { valid: false } };
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/company-details/details/company-details-details.ts